export const isMobile = () => {
    if (!process.browser) {
        return true;
    }
    return /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
};
